import React from 'react'
import { FormGroup, Button } from 'reactstrap'
import Resx from '@/components/Resx'
import { Icon } from '@/components/Icon'
import { DropDownList } from '@/components/dropDownList'
import { localized } from '@/decorators/localized'

@localized()
class LanguageSelector extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      language: props.languageSettings.language
    }
  }
  handleChange = (e) => {
    this.setState({ language: e.value })
  }
  handleSaveClick = (e) => {
    this.props.update(this.state.language)
  }
  render () {
    const { localize, languageSettings } = this.props
    const { updating } = languageSettings
    const data = [
      { value: 'en', text: localize('Common.English') },
      { value: 'ar', text: localize('Common.Arabic') }
    ]
    return (
      <div className='pref-language'>
        <FormGroup>
          <DropDownList
            data={data}
            valueField='value'
            textField='text'
            onChange={this.handleChange}
            value={this.state.language}
          />
        </FormGroup>
        <div className='text-right'>
          <Button color='success' onClick={this.handleSaveClick}><Icon name={updating ? 'loader bx-spin' : 'save'} /><Resx name='Common.Save' /></Button>
        </div>
      </div>
    )
  }
}

export {
  LanguageSelector
}



// WEBPACK FOOTER //
// ./src/components/userProfile/languageSettings/languageSelector.js